import { render } from "./ListadoVentas.vue?vue&type=template&id=0332c880"
import script from "./ListadoVentas.vue?vue&type=script&lang=js"
export * from "./ListadoVentas.vue?vue&type=script&lang=js"

import "./ListadoVentas.vue?vue&type=style&index=0&id=0332c880&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__